<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-dialog
      v-model="privacidad_dialog"
      max-width="80%"
      persistent
    >
      <v-card>
        <v-layout wrap v-show="mascota_privacidad">
          <embed :src="this.mascota_privacidad" type="application/pdf"
            width="100%" height="600px"/>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat" @click="close_privacidad_dialog">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirm_deleted_dialog"
      max-width="900"
    >
      <v-card>
        <v-card-title class="headline">
          Confirmación
        </v-card-title>
        <v-card-text v-if="this.mascota_info.mascota_id">
          ¿Está seguro que desea eliminar a la mascota: <span class="font-weight-bold">{{`${this.mascota_info.nombre}`}}</span>?
        </v-card-text>
        <v-card-text v-else>
          <div class="text-xs-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat"
                 @click="confirm_deleted_dialog = false">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 @click="delete_mascota_confirm"
                 v-if="this.mascota_info.mascota_id"
          >
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 v-else
                 disabled
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container grid-list-md fluid>
      <v-alert
        :value="alert"
        dismissible
        :type="alertType"
      >
        {{ alertMessage }}
      </v-alert>
      <v-layout wrap>
        <v-flex xs12 sm6 md11>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="presearch"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            />
          </v-card-title>
        </v-flex>
        <v-flex xs12 sm6 md1 class="pt-4">
          <v-btn color="primary" dark @click.prevent="agregar_mascota()" v-show="add_btn === true"
                 :disabled="!add_btn">
            Agregar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="mascotas"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="is_loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ props.item.nombre }}</td>
          <td class="text-xs-left">{{ props.item.especie }}</td>
          <td class="text-xs-left">{{ props.item.raza }}</td>
          <td class="text-xs-left">{{ props.item.propietario_vivienda }}</td>
          <td class="text-xs-left">
            {{ props.item.propietario_nombre }} {{ props.item.propietario_apellido_paterno }} {{ props.item.propietario_apellido_materno }}
          </td>
          <td class="text-xs-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="mostrar_mascota(props.item.id)" v-show="view_btn === true"
                        :disabled="!view_btn" v-on="on" class="mr-2" small>
                  visibility
                </v-icon>
              </template>
              <span>Detalles de la Mascota</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="editar_mascota(props.item.id)"
                        v-show="edit_btn === true" :disabled="!edit_btn"
                        v-on="on" class="mr-2" small>
                  edit
                </v-icon>
              </template>
              <span>Editar Mascota</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="show_aviso_privacidad(props.item.id)"
                        v-show="file_btn === true" v-on="on" class="mr-2" small>
                  picture_as_pdf
                </v-icon>
              </template>
              <span>Aviso de Privacidad</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon @click="show_delete_mascota_dialog(props.item.id, props.item.nombre)"
                        v-show="delete_btn === true" :disabled="!delete_btn"
                        v-on="on" class="mr-3" small>
                  delete
                </v-icon>
              </template>
              <span>Eliminar Residente</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { getJWTData } from '../common/jwt.service';

export default {
  data: () => ({
    mascotas: [],
    totalItems: 0,
    pagination: {},
    timer: '',
    search: null,
    presearch: null,
    searchTimer: null,
    valid: true,
    view_btn: false,
    edit_btn: false,
    add_btn: false,
    file_btn: false,
    delete_btn: false,
    privacidad_dialog: false,
    confirm_deleted_dialog: false,
    mascota_privacidad: '',
    mascota_info: {},
    headers: [
      { text: 'id', value: 'id', sortable: false },
      { text: 'Nombre de la Mascota', value: 'nombre', sortable: true },
      { text: 'Especie', value: 'especie', sortable: true },
      { text: 'Raza', value: 'raza', sortable: true },
      { text: 'Vivienda del Propietario', value: 'vivienda_residente_propietario', sortable: false },
      { text: 'Residente Propietario', value: 'nombre_residente_propietario', sortable: false },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
  }),
  computed: {
    is_loading() {
      return this.$store.getters['listadoMascotas/is_loading'];
    },
    mascota_submited() {
      return this.$store.getters['listadoMascotas/mascota_submited'];
    },
    alertType() {
      return this.$store.getters['listadoMascotas/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['listadoMascotas/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['listadoMascotas/alertContainer'];
    },
    alertDialogType() {
      return this.$store.getters['listadoMascotas/alertDialogType'];
    },
    alertDialogMessage() {
      return this.$store.getters['listadoMascotas/alertDialogMessage'];
    },
    alertDialog() {
      return this.$store.getters['listadoMascotas/alertDialog'];
    },
    mascota_processing() {
      return this.$store.getters['listadoMascotas/mascota_processing'];
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.search !== '' && this.search != null) {
          this.getDataFromApi()
            .then((data) => {
              this.mascotas = data.mascotas;
              this.totalItems = data.total;
            });
        }
      },
      deep: true,
    },
    search(val) {
      if (val === '') {
        this.mascotas = [];
        this.totalItems = 0;
      } else {
        this.getDataFromApi()
          .then((data) => {
            this.mascotas = data.mascotas;
            this.totalItems = data.total;
          });
      }
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
  },
  methods: {
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    agregar_mascota() {
      this.$router.push({ name: 'agregar_mascota' });
    },
    editar_mascota(mascotaId) {
      this.$router.push({ name: 'captura_mascota', params: { id: mascotaId } });
    },
    mostrar_mascota(mascotaId) {
      this.$router.push({ name: 'detalles_mascota', params: { id: mascotaId } });
    },
    close_privacidad_dialog() {
      this.mascota_privacidad = '';
      this.privacidad_dialog = false;
    },
    show_aviso_privacidad(mascotaId) {
      this.$store.dispatch('listadoMascotas/showAvisoPrivacidad', mascotaId).then((data) => {
        this.mascota_privacidad = `data:application/pdf;base64,${data}`;
      });
      this.privacidad_dialog = true;
    },
    fetchMascotasList() {
      if (!this.$store.getters['listadoMascotas/is_loading']) {
        this.$store.dispatch('listadoMascotas/clearMascotasAction');
        this.$store.dispatch('listadoMascotas/fetchMascotas');
      }
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, page, rowsPerPage } = this.pagination;

        let { descending } = this.pagination;
        if (descending === null) {
          descending = false;
        }
        const formdata = {
          page,
          per_page: rowsPerPage,
          search: this.search,
          order_by: sortBy,
          descending,
        };
        this.$store.dispatch('listadoMascotas/fetchMascotas', formdata)
          .then((data) => {
            // console.log(data);
            this.loading = false;
            const { mascotas, total } = data;
            this.$store.commit('listadoMascotas/fetchedMascotas');
            resolve({
              mascotas,
              total,
            });
          });
      });
    },
    show_delete_mascota_dialog(mascotaId, mascotaNombre) {
      // this.$store.dispatch('detallesMascota/fetchMascotaInfo', mascotaId);
      this.mascota_info = { mascota_id: mascotaId, nombre: mascotaNombre };
      this.confirm_deleted_dialog = true;
    },
    delete_mascota_confirm() {
      this.confirm_deleted_dialog = false;
      this.$store.dispatch('listadoMascotas/deleteMascota', this.mascota_info.mascota_id).then(() => {
        this.getDataFromApi().then((data) => {
          this.mascotas = data.mascotas;
          this.totalItems = data.total;
        });
      });
      this.mascota_info = {};
    },
  },
  created() {
    this.user_login_role = getJWTData().user_claims.role;
    if (['admin', 'atencion_residentes', 'avisos', 'jefe_monitoristas', 'monitoristas', 'admin_eko', 'censo_residentes', 'censo_domesticos',
      'censo_mascotas'].includes(this.user_login_role)) {
      if (['admin', 'admin_eko', 'censo_residentes', 'censo_domesticos', 'censo_mascotas'].includes(this.user_login_role)) {
        this.view_btn = true;
        this.edit_btn = true;
        this.add_btn = true;
        this.file_btn = true;
        this.delete_btn = true;
      } else if (['atencion_residentes', 'avisos', 'jefe_monitoristas', 'monitoristas'].includes(this.user_login_role)) {
        this.view_btn = true;
      }
    }
  },
  beforeDestroy() {
    this.cancelSearchTimer();
  },
  mounted() {
    /*
    this.$store.dispatch('detallesMascota/fetchMascotaInfo', this.$route.params.id)
      .then((data) => {
        this.mascota_info = data;
      });
    */
  },
};
</script>
<style type="text/css">
</style>
